module.exports = __webpack_public_path__ + "static/img/6b.32f2f23.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/6b.jpg
// module id = tshg
// module chunks = 1